// @flow

import * as React from 'react';
import { Box, Image } from 'grommet/es6';
import { Link as GrommetLink } from 'react-router-dom';
import shortLogo from 'esm-web-pro/assets/images/logo_short.svg';
import styled from 'styled-components';
import { getIsLandingTab } from 'esm-web-pro/redux/landingTab';
import { useSelector } from 'react-redux';

type Props = {
    type: 'short' | 'long',
    width: string,
    height: string,
    background: Object,
}

const Link = styled(GrommetLink)`
  pointer-events: none;
  &:focus {
    outline: none;
  }
`;

const Brand = (props: Props) => {
    const {
        type, width, height, background,
    } = props;
    const isLandingTab = useSelector(getIsLandingTab);

    return (
        <Box background={background} height="100%" justify="center">
            <Link to="/" target={isLandingTab ? '_blank' : '_self'}>
                <Box align="center">
                    <Image src={shortLogo} style={{ width, height }} />
                </Box>
            </Link>
        </Box>
    );
};

export default Brand;
